(function () {
  "use strict";

  if (!window.DNB) {
    //console.warn("DNB namespace not found");
    return;
  }

  window.DNB.register(function () {
    var stack = document.querySelector("[data-awards-stack]");
    if (!stack || !window.gsap || !window.ScrollTrigger) {
      //console.log("Awards stack animation skipped");
      return;
    }

    var copyBlocks = Array.prototype.slice.call(
      document.querySelectorAll(".awards__copy--left, .awards__copy--right")
    );
    if (copyBlocks.length) {
      window.gsap.set(copyBlocks, {
        y: 40,
        opacity: 0,
        rotate: 6,
        transformOrigin: "left bottom"
      });
      copyBlocks.forEach(function (block) {
        if (block.dataset.awardsCopyReveal === "true") {
          return;
        }
        block.dataset.awardsCopyReveal = "true";

        var triggerOptions = {
          trigger: block,
          start: "top 90%",
          invalidateOnRefresh: true,
          onEnter: function () { 
            window.gsap.to(block, {
              y: 0,
              opacity: 1,
              rotate: 0,
              duration: 0.6,
              ease: "expo.out"
            });
          },
          onEnterBack: function () {
            window.gsap.to(block, {
              y: 0,
              opacity: 1,
              rotate: 0,
              duration: 0.6,
              ease: "expo.out"
            });
          }
        };

        if (window.DNB.scroller) {
          triggerOptions.scroller = window.DNB.scroller;
        }

        window.ScrollTrigger.create(triggerOptions);
      });
    }

    var allCards = Array.prototype.slice.call(stack.querySelectorAll(".award-card"));
    if (!allCards.length) {
      //console.log("No award cards found");
      return;
    }

    var orderedCards = [
      stack.querySelector(".award-card--back"),
      stack.querySelector(".award-card--mid"),
      stack.querySelector(".award-card--front")
    ].filter(Boolean);

    var cards = orderedCards.length ? orderedCards : allCards;
    var positions = [
      { x: 0, y: 0, rotation: -6.727, scale: 1 },
      { x: 0, y: 0, rotation: 3.077, scale: 1 },
      { x: 0, y: 0, rotation: 0, scale: 1 }
    ];

    var revealCards = cards;
    var pinTarget = stack.closest(".awards__inner") || stack;
    var triggerTarget = stack.closest(".awards") || stack;
    var revealCount = Math.max(1, revealCards.length);
    var stackRect = stack.getBoundingClientRect();
    var originOffset = stackRect.height ? stackRect.height * 0.6 : 320;

    function setInitialCards() {
      cards.forEach(function (card, index) {
        window.gsap.set(card, {
          x: 0,
          y: originOffset,
          rotation: 0,
          scale: 0.96,
          opacity: 0,
          transformOrigin: "center center",
          zIndex: index + 1
        });
      });
    }

    function buildTimeline(options) {
      var scrollTriggerOptions = {
        trigger: triggerTarget,
        start: options.start,
        end: options.end,
        scrub: options.scrub,
        pin: options.pin,
        pinSpacing: options.pinSpacing,
        invalidateOnRefresh: true
      };

      if (options.once) {
        scrollTriggerOptions.once = true;
      }

      if (options.toggleActions) {
        scrollTriggerOptions.toggleActions = options.toggleActions;
      }

      if (window.DNB.scroller) {
        scrollTriggerOptions.scroller = window.DNB.scroller;
      }

      var tl = window.gsap.timeline({
        scrollTrigger: scrollTriggerOptions
      });

      revealCards.forEach(function (card, orderIndex) {
        var index = cards.indexOf(card);
        var pos = positions[index] || {
          x: 0,
          y: index * 16,
          rotation: (index - 1) * 2,
          scale: 1 - index * 0.03
        };

        tl.to(card, {
          x: pos.x,
          y: pos.y,
          rotation: pos.rotation,
          scale: pos.scale,
          opacity: 1,
          ease: "none",
          duration: 0.3
        }, orderIndex === 0 ? 0 : ">");
      });

      return tl;
    }

    setInitialCards();

    var mm = window.gsap.matchMedia();

    mm.add("(min-width: 641px)", function () {
      setInitialCards();
      var tl = buildTimeline({
        start: "bottom bottom",
        end: "+=" + revealCount * 50 + "%",
        scrub: true,
        pin: pinTarget,
        pinSpacing: true
      });

      return function () {
        tl.kill();
        if (tl.scrollTrigger) {
          tl.scrollTrigger.kill();
        }
        setInitialCards();
      };
    });

    mm.add("(max-width: 640px)", function () {
      setInitialCards();
      var tl = buildTimeline({
        start: "top 80%",
        end: "bottom 20%",
        scrub: false,
        pin: false,
        pinSpacing: false,
        once: true
      });

      return function () {
        tl.kill();
        if (tl.scrollTrigger) {
          tl.scrollTrigger.kill();
        }
        setInitialCards();
      };
    });
  });
})();
